import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: {},
    selectedBoardId: "",
    appVersion: "",
    reportUser: []
  },
  mutations: {
    udtFus(state, payload) {
      state.userInfo.fusKrw = payload;
    },
    udtAccountCoin(state, payload) {
      state.userInfo.accountCoin = payload;
    },
    udtTicketCnt(state, payload) {
      state.userInfo.ticketCnt = payload;
    }, 
    udtBoardId(state, payload) {
      state.selectedBoardId = payload;
    },
    udtactivityNewCnt(state, payload) {
      state.userInfo.activityNewCnt = payload;
    },
    udtReportUser(state, payload) {
      state.userInfo.reportUser = payload;
    }
  },
  actions: {
  },
  modules: {
  }
})
